import styles from './ProfileChangeList.module.scss';

export type ProfileChangeRow = {
  field?: string;
  label: string;
  change_type?: string;
  before?: string | null;
  after?: string | null;
};

function plain(value?: string | null): string {
  const raw = String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!raw || raw === '—' || raw === '-') return ' - ';
  if (raw.length > 180) return `${raw.slice(0, 177).trim()}...`;
  return raw;
}

export function ProfileChangeList({
  title,
  rows,
  empty,
}: {
  title: string;
  rows: ProfileChangeRow[];
  empty?: string;
}) {
  if (!rows.length) {
    return empty ? <p className={styles.empty}>{empty}</p> : null;
  }
  return (
    <div className={styles.list}>
      <p className={styles.title}>{title}</p>
      <ul>
        {rows.map((row, index) => {
          const before = plain(row.before);
          const after = plain(row.after);
          return (
            <li key={`${row.field || row.label}-${index}`}>
              <p className={styles.label}>{row.label}</p>
              <p className={styles.line} title={String(row.before || '')}>
                Было: {before}
              </p>
              <p className={styles.line} title={String(row.after || '')}>
                Стало: {after}
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
